import React, { useEffect, useState } from 'react';
import classes from "./OtpPage.module.css";
import { getProductListApi, printLogsApi, sendOTPApi, verifyOTPApi } from '../Http/http';
import Loader from '../Components/Loader';
import { FaCheck } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';

const OtpPage = () => {

    const [pack, setPack] = useState(null);
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState("");
    const [otp, setOtp] = useState("");
    const [timeLeft, setTimeLeft] = useState(300);

    const location = useLocation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setPack(location?.state?.pack);
        }
        else {
            // navigate("/");
        }
    }, [location]);

    // handle timer countdown
    useEffect(() => {
        if (timeLeft <= 0) {
            toast.error("OTP Expired!");
            navigate("/");
            return;
        };
        const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
        return () => clearInterval(timer);
    }, [timeLeft]);

    // format time as MM:SS
    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m < 10 ? "0" + m : m}:${s < 10 ? "0" + s : s}`;
    };

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();

            if (otp.length <= 4) {
                return;
            }

            setLoading(true);
            const response = await verifyOTPApi({
                MSISDN: msisdn,
                ServiceId: pack,
                ConsentNo: otp
            });
            console.log(response, 'response===');

            const response2 = await printLogsApi({
                data: response?.data
            })

            setLoading(false);

            // if (response?.data?.statusCode == 200 && response?.data?.message == 'Successfull') {
            if (response?.data?.statusCode == 200) {
                console.log("OTP sent successfully");
                navigate("/subscription-processing", {
                    state: {
                        msisdn: msisdn,
                    }
                })
            }
            else if (response?.data?.statusCode == 500) {
                toast.error(response?.data?.message);
            }
            else {
                toast.error(response?.data?.message || "Failed to Verify OTP. Please try again.");
            }

        } catch (error) {

            console.log(error?.response?.data?.error);

            const apiError = error?.response?.data?.error;
            const errMsg = apiError == "Failed"
                ? "Invalid OTP. Please input a valid OTP."
                : apiError || "Something went wrong. Please try again.";

            toast.error(errMsg);

            const response2 = await printLogsApi({
                data: error?.response
            })

            setLoading(false);
        }
    }
    return (
        <div className={classes.container}>
            <div className={classes.slider_content}>
                <h2 className="tlt fix" data-in-effect="fadeInLeft">Door<span> 2 </span>Games</h2>
                <p className="wow fadeInUp" data-wow-delay="2s">
                    Dive into 50+ thrilling games across action, puzzle, sports, and more. There's something for every player!
                </p>
            </div>
            <div className={classes.section_hero}>

                <div className={classes.section_stack1}>
                    {profileImages?.slice(0, 10).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}

                    {profileImages?.slice(0, 10).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}
                </div>

                <div className={classes.section_stack1}>
                    {profileImages?.slice(10, 20).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}

                    {profileImages?.slice(10, 20).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}
                </div>

                <form className={classes.subscription_form} onSubmit={handleSubmit}>

                    <h3 className={classes.title}>Enter OTP</h3>
                    <p className={classes.info}>OTP will expire within 5 minutes</p>

                    <div className={classes.timer}>
                        ⏳ Time Remaining: <span className={classes.timer_bold}>{formatTime(timeLeft)}</span>
                    </div>

                    <div className={classes.otp_input_container}>
                        <OTPInput
                            value={otp}
                            shouldAutoFocus
                            onChange={setOtp}
                            numInputs={5}
                            renderSeparator={<span className={classes.gap}></span>}
                            renderInput={(props) => (
                                <input {...props} type="number" className={classes.input_box} />
                            )}
                        />
                    </div>


                    <button className={classes.next_button} type="submit" disabled={loading}>
                        {loading ? "Verifying OTP..." : "Continue"}
                    </button>

                    <button className={classes.back_button} type="button" disabled={loading}
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>

                </form>

            </div>
        </div>


    )
}

export default OtpPage;


const profileImages = [
    "/assets/game-images/crazy_match3_512x512.png",
    "/assets/game-images/danger%20runing.png",
    "/assets/game-images/delta_512x512.png",
    "/assets/game-images/double_stickman_512x512.png",
    "/assets/game-images/dragonjump_512x512.png",
    "/assets/game-images/duckshooter_512x512.png",
    "/assets/game-images/emoji%20squeeze.png",
    "/assets/game-images/faces_match_512x512.png",
    "/assets/game-images/feed.png",
    "/assets/game-images/fishnjump_512x512.png",
    "/assets/game-images/flying%20boy.png",
    "/assets/game-images/follow_line_512x512.png",
    "/assets/game-images/Aliens_Memory_512x512.png",
    "/assets/game-images/AngryCatShot_512x512.png",
    "/assets/game-images/AnimalFun_512x512.png",
    "/assets/game-images/BrickDodge_512x512.png",
    "/assets/game-images/CholiJet_512x512.png",
    "/assets/game-images/DangerousCircle_512x512.png",
    "/assets/game-images/Dark_Ninja_512x512.png",
    "/assets/game-images/Emoji_Pong_512x512.png"
];